import { getCategoryHref } from '../../utils/common/category';
import {
  TITLE_GENERATOR_CATEGORY,
  BLOG_TITLE_GENERATOR_CATEGORY,
  BOOK_TITLE_GENERATOR_CATEGORY,
  DOCUMENT_TITLE_GENERATOR_CATEGORY,
  CONTENT_TITLE_GENERATOR_CATEGORY,
  LANDING_PAGE_TITLE_GENERATOR_CATEGORY,
  SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY,
  STORY_TITLE_GENERATOR_CATEGORY,
  VIDEO_TITLE_GENERATOR_CATEGORY,
} from '../../constants';

const chipValues = [
  {
    title: 'All',
    value: getCategoryHref(TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Blog',
    value: getCategoryHref(BLOG_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Book',
    value: getCategoryHref(BOOK_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Content',
    value: getCategoryHref(CONTENT_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Document',
    value: getCategoryHref(DOCUMENT_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Landing page',
    value: getCategoryHref(LANDING_PAGE_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Social media post',
    value: getCategoryHref(SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Story',
    value: getCategoryHref(STORY_TITLE_GENERATOR_CATEGORY),
  },
  {
    title: 'Video',
    value: getCategoryHref(VIDEO_TITLE_GENERATOR_CATEGORY),
  },
];

export { chipValues };
